import React from "react";

export default function HeadingTitle(props) {
   // Propriétés des Titles
   const { children, variant } = props;

   const defaultClass =
      "px-7 py-3 font-secondary text-secondary bg-primary uppercase font-semibold tracking-tight inline-block ";

   switch (variant) {
      case "h3":
         return (
            <div className="flex items-center justify-center my-5">
               <h3 className={`${defaultClass} text-xl`}>{children}</h3>
            </div>
         );

      default:
         return (
            <div className="flex items-center justify-center">
               <h2 className={`${defaultClass} text-2xl`}>{children}</h2>
            </div>
         );
   }
}
